<div class="wizard-users">
  <section class="wizard-section">
    <h5 class="wizard-heading-1">{{ "invite_users" | translation }}</h5>
    <p class="wizard-content">
      {{ "provide_emails_below_for_each_user_wizard_lingo" | translation }}
    </p>
  </section>
  <section class="wizard-section">
    <h5 class="wizard-heading-1">{{ "user_emails" | translation }}</h5>
    <textarea
      [(ngModel)]="input"
      class="wizard-users-emails-input"
      [placeholder]="'paste_user_emails' | translation"
    ></textarea>
    <div class="wizard-button-container">
      <button (click)="processEmails()" class="text-link-color" nbButton ghost>
        <i class="fa-solid fa-file-import fa-fw text-link-color"></i
        >{{ "process" | translation }}
      </button>
    </div>
  </section>

  <section class="wizard-section" *ngIf="usersFormArray?.length">
    <div class="wizard-users-container" [formGroup]="usersFormArray">
      <div class="wizard-users-label-container">
        <label class="wizard-users-label-email">{{
          "email" | translation
        }}</label>
        <label class="wizard-users-label-username">{{
          "username" | translation
        }}</label>
        <label class="wizard-users-label-role">{{
          "role" | translation
        }}</label>
        <label class="wizard-users-label-status">{{
          "status" | translation
        }}</label>
        <label class="wizard-users-label-delete-wrapper"> </label>
      </div>
      <div
        *ngFor="let userGroup of usersFormArray?.controls; let i = index"
        [formGroupName]="i"
      >
        <div class="wizard-users-field-container">
          <nb-form-field class="wizard-users-field-email">
            <input
              type="text"
              nbInput
              formControlName="email"
              [ngClass]="
                userGroup?.get('email')?.errors
                  ? 'wizard-input-invalid'
                  : 'wizard-input-valid'
              "
            />

            <div class="wizard-label-error-wrapper">
              <span
                class="wizard-label-error"
                *ngIf="
                  userGroup?.get('email')?.errors &&
                  userGroup?.get('email')?.errors?.required
                "
              >
                <i class="fa-solid fa-triangle-exclamation"></i>
                Required
              </span>
              <span
                class="wizard-label-error"
                *ngIf="
                  userGroup?.get('email')?.errors &&
                  userGroup?.get('email')?.errors?.whitespace &&
                  !userGroup?.get('email')?.errors?.required
                "
              >
                <i class="fa-solid fa-triangle-exclamation"></i>
                {{ "no_spacing" | translation }}
              </span>
              <span
                class="wizard-label-error"
                *ngIf="
                  userGroup?.get('email')?.errors &&
                  !userGroup?.get('email')?.errors?.required &&
                  !userGroup?.get('email')?.errors?.whitespace &&
                  userGroup?.get('email')?.errors.email
                "
              >
                <i class="fa-solid fa-triangle-exclamation"></i>
                {{ "needs_to_be_an_email" | translation }}
              </span>
              <span
                class="wizard-label-error"
                *ngIf="
                  userGroup?.get('email')?.errors?.notUnique &&
                  !userGroup?.get('email')?.errors.email &&
                  !userGroup?.get('email')?.errors?.whitespace &&
                  !userGroup?.get('email')?.errors?.required
                "
              >
                <i class="fa-solid fa-triangle-exclamation"></i>
                {{ "duplicate_email" | translation }}
              </span>
            </div>
          </nb-form-field>
          <nb-form-field class="wizard-users-field-username">
            <input
              type="text"
              nbInput
              formControlName="username"
              [ngClass]="
                userGroup?.get('username')?.errors
                  ? 'wizard-input-invalid'
                  : 'wizard-input-valid'
              "
            />

            <div class="wizard-label-error-wrapper">
              <span
                class="wizard-label-error"
                *ngIf="
                  userGroup?.get('username')?.errors?.notUnique &&
                  !userGroup?.get('username')?.errors.pattern &&
                  !userGroup?.get('username')?.errors?.whitespace &&
                  !userGroup?.get('username')?.errors?.required
                "
              >
                <i class="fa-solid fa-triangle-exclamation"></i>
                {{ "duplicate_username" | translation }}
              </span>
              <span
                class="wizard-label-error"
                *ngIf="
                  userGroup?.get('username')?.errors &&
                  userGroup?.get('username')?.errors?.whitespace &&
                  !userGroup?.get('username')?.errors?.required
                "
              >
                <i class="fa-solid fa-triangle-exclamation"></i>
                {{ "no_spacing" | translation }}
              </span>
              <span
                class="wizard-label-error"
                *ngIf="
                  userGroup?.get('username')?.errors &&
                  userGroup?.get('username')?.errors?.required
                "
              >
                <i class="fa-solid fa-triangle-exclamation"></i>
                {{ "required" | translation }}
              </span>
              <span
                class="wizard-label-error"
                *ngIf="
                  userGroup?.get('username')?.errors &&
                  !userGroup?.get('username')?.errors?.required &&
                  !userGroup?.get('username')?.errors?.whitespace &&
                  userGroup?.get('username')?.errors?.pattern
                "
              >
                <i class="fa-solid fa-triangle-exclamation"></i>
                {{ "cannot_be_an_email" | translation }}
              </span>
            </div>
          </nb-form-field>
          <nb-form-field class="wizard-users-field-role">
            <nb-select placeholder="Select Role" formControlName="role">
              <nb-option [value]="role.name" *ngFor="let role of roles">
                {{ role.title }}
              </nb-option>
            </nb-select>
          </nb-form-field>

          <span class="wizard-users-field-status">
            <nb-form-field>
              <input
                *ngIf="userGroup?.get('status')?.value === 'Standby'"
                type="text"
                nbInput
                [value]="'standby' | translation"
                disabled
                style="padding-left: 8px; background: #fff"
              />
              <input
                *ngIf="userGroup?.get('status')?.value === 'Created'"
                type="text"
                nbInput
                [value]="'created' | translation"
                disabled
                style="padding-left: 8px; background: #fff"
              />
              <input
                *ngIf="userGroup?.get('status')?.value === 'Processing'"
                type="text"
                nbInput
                [value]="'processing' | translation"
                disabled
                style="padding-left: 8px; background: #fff"
              />
              <input
                *ngIf="userGroup?.get('status')?.value === 'Error'"
                type="text"
                nbInput
                [value]="'error' | translation"
                disabled
                style="padding-left: 8px; background: #fff"
              />
            </nb-form-field>
            <span
              *ngIf="userGroup?.get('status')?.value === 'Error'"
              style="position: absolute; top: -1px; left: 42px"
              [nbTooltip]="userGroup?.get('statusMessage')?.value"
              ><i class="fa-light fa-circle-info"></i
            ></span>
          </span>
          <div class="wizard-users-field-delete-button-wrapper">
            <button
              [disabled]="userGroup?.get('status')?.value === 'Processing'"
              class="wizard-users-field-delete-button text-link-color"
              nbButton
              ghost
              (click)="deleteUser(i)"
            >
              <i class="far fa-trash-alt text-link-color"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="wizard-button-container">
      <button
        (click)="createUserAccounts()"
        class="text-link-color"
        nbButton
        ghost
        [disabled]="!usersFormArray.valid || isProcessing"
      >
        <i class="fa-thin fa-pen text-link-color"></i
        >{{ "create_accounts" | translation }}
      </button>
    </div>
  </section>
</div>
